import UIManager from "../../Shared/UIManager";
import NetworkLogic from "../../Shared/NetworkLogic";
import SDKManager from "../../Shared/SDKManager";
import AudioManager from "../../Shared/AudioManager";
const {ccclass, property} = cc._decorator;

@ccclass
export default class ShareToWeChat extends cc.Component {

    private shareData = null;


    updateUI(data){
        this.shareData = data;
    }

    async onBtnClick(event, param) {
        AudioManager.playSound("button");

        if (param === "qq") {//qq分享
            //UIManager.showLoadingUI();
            SDKManager.shareURL({
                url: this.shareData.codeAddress,
                platformType: SDKManager.UMSocialPlatformType.QQ,
                title: this.shareData.shareTitle,
                describe: this.shareData.shareText,
                thumbUrl: this.shareData.promoteTheAddress,
            }, function (index) {
                //UIManager.hideLoadingUI();
                cc.log("=====qq分享param：", index);
                if (index === 0 || index === "0") {
                    UIManager.showToastUI("分享失败，请安装或检查QQ后重试")
                }
            }.bind(this))

        } else if (param === "wx") {//微信分享
            //UIManager.showLoadingUI();
            SDKManager.shareURL({
                url: this.shareData.codeAddress,
                platformType: SDKManager.UMSocialPlatformType.WechatSession,
                title: this.shareData.shareTitle,
                describe: this.shareData.shareText,
                thumbUrl: this.shareData.promoteTheAddress,
            }, function (index) {
                //UIManager.hideLoadingUI();
                if (index === 0 || index === "0") {
                    UIManager.showToastUI("分享失败，请安装或检查微信后重试")
                }
            }.bind(this))
        } else if (param === "pyq") {//朋友圈分享
            UIManager.showLoadingUI();
            SDKManager.shareURL({
                url: this.shareData.codeAddress,
                platformType: SDKManager.UMSocialPlatformType.WechatTimeLine,
                title: this.shareData.shareTitle,
                describe: this.shareData.shareText,
                thumbUrl: this.shareData.promoteTheAddress,
            }, function (index) {
                UIManager.hideLoadingUI();
                if (index === 0 || index === "0") {
                    UIManager.showToastUI("分享失败，请安装或检查微信后重试")
                }
            }.bind(this))
        }
    }
    onBtnClose(event,param){
        AudioManager.playSound("close");
        this.node.destroy();
    }
}
